import { motion } from "framer-motion";

export const MOSAIC = ["#EF2122", "#EF6237", "#FDE91F", "#5C876B", "#0256B3", "#F68E93", "#405F6C", "#4D2F57", "#EE852F"];

export const mosaicGradient = (size = 10) =>
  `repeating-linear-gradient(90deg, ${MOSAIC.map((c, i) => `${c} ${i * size}px ${(i + 1) * size}px`).join(", ")})`;

export const Tiles = ({ count = 5, size = 7, className = "", offset = 0, animate = true }) => (
  <span className={`inline-flex items-center gap-[3px] ${className}`} aria-hidden data-testid="mosaic-tiles">
    {Array.from({ length: count }).map((_, i) => (
      <motion.span
        key={i}
        style={{ width: size, height: size, background: MOSAIC[(i + offset) % MOSAIC.length] }}
        initial={animate ? { scale: 0, opacity: 0 } : false}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: i * 0.06, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="block"
      />
    ))}
  </span>
);

export const MosaicStrip = ({ className = "", size = 10, height = 4 }) => (
  <motion.div
    aria-hidden
    data-testid="mosaic-strip"
    className={`w-full origin-left ${className}`}
    style={{ height, backgroundImage: mosaicGradient(size) }}
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
  />
);
